import React from "react";
import searcher from "../../../assets/icons/searchInput.svg";
import CustomersListTable from "./customer-list-table";
import MainLayout from "../../../components/layout/mainLayout/mainLayout";
import VersionHistoryBtn from "../../../components/buttons/versionHistoryBtn";
import { useLocation, useNavigate } from "react-router-dom";

const CustomersList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const status = queryParamsData.get("status") ?? "";
  const search = queryParamsData.get("search") ?? "";

  const queryParams = [];
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <MainLayout breadCrumb="ADMIN  /  Customers">
      <div>
        <div className="search-container d-flex justify-content-between ">
          <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
            <img className="styled-SVG" src={searcher} alt="o" />
            <input
              value={search}
              className="search-input fs_14 fw_400 text-dark px-2"
              type="text"
              placeholder="Search customers here by Jivini’s Doctor Code, Jivini’s Pharmacy Code, Doctor Name, Pharmacy Name..."
              onChange={(e) => {
                navigate(
                  `/customers/customer?page=1${
                    e.target.value ? `&search=${e.target.value}` : ""
                  }${queryString}`
                );
              }}
            />
          </div>
          <div className=" d-flex justify-content-between m-1 mb-2">
            <button
              onClick={() => navigate(`/distributors/distributor/version-list`)}
              className="py-1 border-0 rounded-2 mx-2 px-3 fs_14 Medium_Purple"
            >
              Clear Filters
            </button>
            <VersionHistoryBtn link="/customers/customer/version-list" />
          </div>
        </div>

        <CustomersListTable search={search} status={status} page_no={page_no} />
      </div>
    </MainLayout>
  );
};

export default CustomersList;
